<div *ngIf="vehicle" class="vehicle-details-header">
    <div class="header">

        <div *ngIf="editMode == false">
            <div [style.color]="'black'" class="title" [title]="vehicle.Nm">
                <span>{{ vehicle.Nm }}</span>
            </div>
            <div *ngIf="hasPermissionToEditVehicleName" class="btn-edit" (click)="showEditVehicleNameModal()">
                <i class="pi pi-pencil"></i>
            </div>
        </div>
        <div *ngIf=" editMode == true">
            <div [style.color]="'white'" class="title" [title]="vehicle.Nm">
                <span>{{ vehicle.Nm }}</span>
                <input class='vehicle-name-input' type="text" [value]="editValue" #vehicleName>
                <div class="btn-save-vehicle-name" (click)="saveVehicleName(vehicleName.value)"></div>
                <div class="btn-close-edit-vehicle-name" (click)="closeEditVehicleName()"></div>
            </div>
        </div>

        <div 
            *ngIf="!editMode"
            class="btn-close"
            (click)="closeClick()"
            [routerLink]="['/panel' , 'vehicle']"
            [queryParams]="{mode:'lite'}"
        >
            <i class="pi pi-times"></i>
        </div>
        <!-- last updated -->
        <!-- <tk-vehicle-last-updated [vehicle]="vehicle"></tk-vehicle-last-updated> -->

    </div>

    <!-- <div class="info">
        <div class="plates" *ngIf="vehicle.RN">{{ vehicle.RN | slice:0:10 }}</div>
        <tk-vehicle-current-driver [driver]="vehicle.LastDriver"></tk-vehicle-current-driver>
    </div> -->

</div>
